import React from "react";
import * as Phosphor from "@phosphor-icons/react";
import Reveal from "./Reveal";
import { useLang } from "../context/LanguageContext";

function Icon({ name, size = 28 }) {
  const map = {
    ForkKnife: Phosphor.ForkKnife,
    UserCircle: Phosphor.UserCircle,
    WifiHigh: Phosphor.WifiHigh,
    Barbell: Phosphor.Barbell,
    CocktailIcon: Phosphor.Martini,
    Car: Phosphor.Car,
    Wifi: Phosphor.WifiHigh,
    Television: Phosphor.Television,
    Snowflake: Phosphor.Snowflake,
    Coffee: Phosphor.Coffee,
    Bathtub: Phosphor.Bathtub,
    Armchair: Phosphor.Armchair,
    Wine: Phosphor.Wine,
    CityOutline: Phosphor.Buildings,
  };
  const C = map[name] || Phosphor.Sparkle;
  return <C size={size} weight="light" />;
}

export default function ServicesStrip({ services = [] }) {
  const { t, lang } = useLang();
  const items = services.filter((s) => s.homepage !== false).slice(0, 6);

  return (
    <section className="relative py-24 lg:py-40 bg-[#0c0c0e] hairline-top hairline-bottom" data-testid="services-strip">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <Reveal>
            <div className="overline mb-4">{t.services.overline}</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1]">
              {t.services.title.split("\n").map((l, i) => (
                <span key={l || `services-line-${i}`} className="block">{l}</span>
              ))}
            </h2>
            <p className="mt-6 text-white/70 max-w-md">{t.services.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {items.map((s, i) => {
            const name = lang === "it" ? s.name_it : s.name_en;
            const desc = lang === "it" ? s.description_it : s.description_en;
            return (
              <Reveal key={s.id} delay={i * 0.06}>
                <div className="bg-[#0c0c0e] p-8 lg:p-10 h-full hover:bg-[#111113] transition-colors" data-testid={`service-${s.icon}`}>
                  <div className="text-[#C5A059] mb-6"><Icon name={s.icon} /></div>
                  <h3 className="font-serif text-2xl mb-3">{name}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
